import { render, staticRenderFns } from "./ComposeTextPane.vue?vue&type=template&id=f30f9046&scoped=true"
import script from "./ComposeTextPane.vue?vue&type=script&lang=js"
export * from "./ComposeTextPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30f9046",
  null
  
)

export default component.exports